import commissionNetIncomeSaga from 'features/netincome/commissionNetIncomeSaga';
import itemNetIncomeSaga from 'features/netincome/itemNetIncomeSaga';
import totalNetIncomeSaga from 'features/netincome/totalNetIncomeSaga';
import { all, fork } from 'redux-saga/effects';

export default function* netIncomeSaga() {
  yield all([fork(totalNetIncomeSaga), fork(commissionNetIncomeSaga), fork(itemNetIncomeSaga)]);
}
